import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core";
import { primaryApplicationFontFamily } from "shared/theme/defaultTheme";
import { ButtonTextProps } from "./commonButtonsProps";

const useStyles = makeStyles({
    buttonTextType: {
        display: "flex",
        "&.button1": {
            fontFamily: primaryApplicationFontFamily,
            fontWeight: 500,
            fontSize: "0.875rem",
            letterSpacing: "0.078rem",
            textTransform: "uppercase",
        },
        "&.button2": {
            fontFamily: primaryApplicationFontFamily,
            fontWeight: 500,
            fontSize: "0.875rem",
            letterSpacing: "0.00156rem",
        },
    },
});

function ButtonText({ label, textVariant, reference }: ButtonTextProps): JSX.Element {
    const classes = useStyles();
    return (
        <span ref={reference} className={clsx(classes.buttonTextType, textVariant || "button1")}>
            {label}
        </span>
    );
}

export default ButtonText;
